import { render } from "./myPrice.vue?vue&type=template&id=1a4d491c&scoped=true"
import script from "./myPrice.vue?vue&type=script&lang=js"
export * from "./myPrice.vue?vue&type=script&lang=js"

import "./myPrice.vue?vue&type=style&index=0&id=1a4d491c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4d491c"]])

export default __exports__